var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container meeting-wrapper"},[_c('iframe',{staticClass:"adjust-wrapper meeting-iframe",attrs:{"src":"https://p2p.mirotalk.com/join/40f02fa3-6030-415b-afc8-468109511641","allow":"microphone; camera"}})])
}]

export { render, staticRenderFns }